// import LoginForm from '../components/Authentication/LoginForm';
// import logo from '../assets/bigLogo.svg';
// import { Link } from 'react-router-dom';
// import { LoginContainer } from '../components/Authentication/AuthStyles';
// import { Box, Heading, Text } from '@chakra-ui/react';
// import Header from 'components/LandingPageComponents/mobile/Header';
// import { HeaderContainer } from 'components/LandingPageComponents/styles/HeaderStyles';
// import { useScreenWidth } from 'hooks/useScreenWidth';
// import { logoutUser } from 'services/authservices';
// import { useDispatch } from 'react-redux';
// import { useEffect } from 'react';
// const Login = () => {
//     const dispatch = useDispatch();

//     useEffect(() => {
//         logoutUser(dispatch);
//         localStorage.removeItem('token');
//         localStorage.removeItem('refresh_token'); 
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     const screen = useScreenWidth();

//     //  token ? (
//     //         <Navigate to="/dashboard" />
//     //     ) :
//     return (
//         <LoginContainer>
//             {screen <= 500 ? (
//                 <Box pos={'relative'} marginBottom={'54px'}>
//                     <Header />
//                     <HeaderContainer>
//                         <Box marginTop={'54px'}>
//                             <Heading
//                                 as="h1"
//                                 fontSize="32px"
//                                 fontWeight="700"
//                                 color="#2C2C2C"
//                                 mb="8px">
//                                 Hey, Welcome Back!
//                             </Heading>
//                             <Text Text color="#2C2C2C" fontSize="14px" mb="10px">
//                                 Login Now to Experience Obana
//                             </Text>
//                         </Box>
//                     </HeaderContainer>
//                 </Box>
//             ) : (
//                 <div
//                     style={{
//                         padding: '1rem 4rem',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'space-between',
//                     }}>
//                     <Link to="/">
//                         <img src={logo} alt="logo" />
//                     </Link>
//                 </div>
//             )}
//             <LoginForm screen={screen} />
//         </LoginContainer>
//     );
// };

// export default Login;

import { useEffect, useRef } from 'react';
import { Navigate, Link } from 'react-router-dom';
import { Box, Flex, Heading, Image, Text } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import LoginForm from '../components/Authentication/LoginForm';
import { logoutUser } from 'services/authservices';

/* TODO: update this asset path to point at your real logo file. */
import obanaLogo from '../assets/bigLogo.svg';

/* ─────────────────────────────────────────────────────────────
   BRAND TOKENS
   ───────────────────────────────────────────────────────────── */

// const NAVY        = '#1B3B5F';
const INK         = '#1A2740';
const MUTED       = '#5A6B7E';
const SURFACE     = '#FFFFFF';
const SURFACE_ALT = '#F7F9FB';

const FONT = "'Bricolage Grotesque', sans-serif";

/* Read token synchronously so already-authenticated users
   never see the form flash before redirect. */
const getStoredToken = () => {
    if (typeof window === 'undefined') return null;
    try {
        return window.localStorage.getItem('token');
    } catch {
        return null;
    }
};

const Login = () => {
    const dispatch     = useDispatch();
    const token        = getStoredToken();
    const cleanupRanRef = useRef(false);

    /* Defensive cleanup — fires only once, only when no token. */
    useEffect(() => {
        if (token) return;
        if (cleanupRanRef.current) return;
        cleanupRanRef.current = true;

        logoutUser(dispatch);
        try {
            window.localStorage.removeItem('refresh_token');
        } catch {
            /* localStorage may be blocked */
        }
    }, [dispatch, token]);

    if (token) {
        return <Navigate to="/dashboard" replace />;
    }

    return (
        <Flex
            minH="100vh"
            w="full"
            fontFamily={FONT}
            bg={SURFACE_ALT}
            align="center"
            justify="center"
            px={{ base: '16px', md: '24px' }}
            py={{ base: '20px', md: '24px' }}
        >
            <Box w="full" maxW="380px">
                {/* Logo */}
                <Flex justify="center" mb="14px">
                    <Link to="/" aria-label="Obana home">
                        <Image
                            src={obanaLogo}
                            alt="Obana"
                            maxH="30px"
                            objectFit="contain"
                        />
                    </Link>
                </Flex>

                {/* Heading */}
                <Box mb="18px" textAlign="center">
                    <Heading
                        as="h1"
                        fontSize={{ base: '22px', md: '20px' }}
                        fontWeight="800"
                        color={INK}
                        letterSpacing="-0.02em"
                        mb="4px"
                        fontFamily={FONT}
                        lineHeight="1.2"
                    >
                        Welcome back
                    </Heading>
                    <Text fontSize={{ base: '13px', md: '12px' }} color={MUTED}>
                        Sign in to continue to your dashboard
                    </Text>
                </Box>

                <Box bg={SURFACE}>
                    <LoginForm />
                </Box>
            </Box>
        </Flex>
    );
};

export default Login;